import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/component-showcase/fit-on-page')({
    component: RouteComponent,
    staticData: {
        ui: {
            heightVariant: 'fit',
        },
    },
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <div className="flex h-full flex-col overflow-hidden">
                <div className="bg-muted p-4 text-lg">Header</div>
                <div className="flex-1 overflow-auto bg-muted p-4 text-sm">
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                    Rest of the page
                    <br />
                </div>
            </div>
        </PageController>
    );
}
